import * as THREE from 'three';
import UtilSP from 'SATPROF_UTILS/UtilSP';


// import { LineMaterial } from "three/addons/lines/LineMaterial.js";
// import { LineGeometry } from "three/addons/lines/LineGeometry.js";
// import { Line2 } from "three/addons/lines/Line2.js";
import { Line2 } from "three/examples/jsm/lines/Line2";
import { LineMaterial } from "three/examples/jsm/lines/LineMaterial";
import { LineGeometry } from "three/examples/jsm/lines/LineGeometry";

export default class ArcLine_grp  extends THREE.Group{
   
    /* 
    Draws an arc in the x-y plane, starting on the x axis, going towards the y axis
    */

    private arcLine_m:Line2;
    private arcLine_g:LineGeometry;
    private arcLine_mat:LineMaterial;
    private arcPoints:Array<THREE.Vector3>;
    private arcPositions: Array<number>;
    private squarePoints:Array<THREE.Vector3>;
    private squarePositions:Array<number>;
    private _nPoints:number = 10;
    private _arcAngle:number = 30;
    private _arcRadius:number = 400;
    private _arcColor:string = "yellow";
    private _enableRightAngle:boolean = true;
    private _lineWidth:number = 1;

    constructor(){
        super();
        //console.log("In ArcLine_grp constructor...")
        this.createObject();
    }
    
    //let axesHelper = new THREE.AxesHelper( 5 );  
    private createObject(){
 
        this.arcPoints = []
        this.arcPositions = []
        this.squarePoints = [];

        this.arcPoints.push(new THREE.Vector3(0,0,0));
        this.arcPoints.push(new THREE.Vector3(400,500,0));
        this.arcPositions = this.arcPoints.flatMap((point: THREE.Vector3) => [point.x, point.y, point.z]);
 
        //this.arcLine_mat = new THREE.LineBasicMaterial( {color:this._arcColor, linewidth:10 } )
        this.arcLine_mat = new LineMaterial( {color:this._arcColor, linewidth:2 } )
        //this.arcLine_g = new THREE.BufferGeometry().setFromPoints(this.arcPoints);
        this.arcLine_g = new LineGeometry();
        this.arcLine_g.setPositions(this.arcPositions);
        //this.arcLine_m = new THREE.Line(this.arcLine_g, this.arcLine_mat);
        this.arcLine_m = new Line2(this.arcLine_g, this.arcLine_mat);
        this.add(this.arcLine_m);  

        this.rebuild();
    }

    public rebuild(){    
 
        this.arcPoints = [];
        let xx:number;
        let yy:number;
        let aa:number;
        for (let i=0; i<=this._nPoints; i++){
            aa = i * this._arcAngle/this._nPoints;
            xx = this._arcRadius * Math.cos(UtilSP.radians(aa));
            yy = this._arcRadius * Math.sin(UtilSP.radians(aa));
            this.arcPoints.push(new THREE.Vector3(xx,yy,0));
            //console.log("xx = "+xx+", yy = "+yy)
        }

        this.arcPositions = this.arcPoints.flatMap((point: THREE.Vector3) => [point.x, point.y, point.z]);

        this.squarePoints = [];
        this.squarePoints.push(new THREE.Vector3(this._arcRadius,0,0));
        this.squarePoints.push(new THREE.Vector3(this._arcRadius,this._arcRadius,0));
        this.squarePoints.push(new THREE.Vector3(0,this._arcRadius,0));

        this.squarePositions = this.squarePoints.flatMap((point: THREE.Vector3) => [point.x, point.y, point.z]);

        if (this._enableRightAngle && Math.abs(this._arcAngle) == 90 ){
            this.arcLine_g = new LineGeometry();
            this.arcLine_g.setPositions(this.squarePositions);
        } else {
        this.arcLine_g = new LineGeometry();
        this.arcLine_g.setPositions(this.arcPositions)
        }
        this.arcLine_m.geometry = this.arcLine_g;

        this.arcLine_mat = new LineMaterial( {color:this._arcColor, linewidth:this._lineWidth } )
        this.arcLine_m.material = this.arcLine_mat;

    }

    public set color(val:string){
        this._arcColor = val;
        this.rebuild();
    }
    public get color():string{
        return this._arcColor;
    }	

    public set radius(val:number){
        this._arcRadius = val;
        this.rebuild();
    }
    public get radius():number{
        return this._arcRadius;
    }
    public set angle(val:number){
        this._arcAngle = val;
        this.rebuild();
    }
    public get angle():number{
        return this._arcAngle;
    }    
    public set nPoints(val:number){
        this._nPoints = val;
        this.rebuild();
    }
    public get nPoints():number{
        return this._nPoints;
    }
    public set lineWidth(val:number){
        this._lineWidth = val;
        this.rebuild();
    }
    public get lineWidth():number{
        return this._lineWidth;
    }
    public set enableRightAngle(val:boolean){
        this._enableRightAngle = val;
        this.rebuild();
    }
    public get enableRightAngle():boolean{
        return this._enableRightAngle;
    }    

}


